import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './station.reducer';
import { coordToString } from 'app/shared/model/geo-point.model';

export const StationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const stationEntity = useAppSelector(state => state.station.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="stationDetailsHeading">
          <Translate contentKey="cabmanApp.station.detail.title">Station</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{stationEntity.id}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="cabmanApp.station.type">Type</Translate>
            </span>
          </dt>
          <dd>{stationEntity.type}</dd>
          <dt>
            <span id="serialNumber">
              <Translate contentKey="cabmanApp.station.serialNumber">Serial Number</Translate>
            </span>
          </dt>
          <dd>{stationEntity.serialNumber}</dd>
          <dt>
            <span id="model">
              <Translate contentKey="cabmanApp.station.model">Model</Translate>
            </span>
          </dt>
          <dd>{stationEntity.model}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="cabmanApp.station.name">Name</Translate>
            </span>
          </dt>
          <dd>{stationEntity.name}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="cabmanApp.station.status">Status</Translate>
            </span>
          </dt>
          <dd>{stationEntity.status}</dd>
          <dt>
            <span id="position">
              <Translate contentKey="cabmanApp.station.position">Position</Translate>
            </span>
          </dt>
          <dd>{coordToString(stationEntity.position)}</dd>
          <dt>
            <Translate contentKey="cabmanApp.station.location">Location</Translate>
          </dt>
          <dd>{stationEntity.location ? stationEntity.location.id : ''}</dd>
          <dt>
            <Translate contentKey="cabmanApp.station.fleet">Fleet</Translate>
          </dt>
          <dd>{stationEntity.fleet ? stationEntity.fleet.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/station" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/station/${stationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default StationDetail;
